module.exports = require("./fr-WF.js");